import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Tracker} from 'shared';
import {WebsocketService} from '../../services/websocket/websocket.service';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {durationToHoursStr} from 'shared';

@Component({
  selector: 'app-fuel-realtime-consumption',
  templateUrl: './fuel-realtime-consumption.component.html',
  styleUrls: ['./fuel-realtime-consumption.component.scss']
})
export class FuelRealtimeConsumptionComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  name: string;

  @Input()
  tracker: Tracker;

  @Input()
  start: boolean;

  @Input()
  width?: number;

  @Input()
  height?: number;

  hourlyRateDs: DataSource;
  hourlyRateStore: ArrayStore;

  private initialized: boolean;
  private isFirst = true;
  private sub: Subscription;

  current: Tracker;

  interval;
  private fuelTotalBase: number;
  private engineHoursBase: number;
  engineHours = 0;
  fuelTotal = 0;

  durationToHoursStr = durationToHoursStr;

  constructor(
    private ws: WebsocketService,
  ) {
  }

  ngOnInit() {
    this.current = this.tracker;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('start')) {
      if (changes.start.currentValue === true) {
        this.startRealtime();
      } else if (!changes.start.firstChange) {
        this.stopRealtime();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private init() {
    if (this.initialized) {
      return;
    }
    this.hourlyRateStore = new ArrayStore({
      data: [],
    });
    this.hourlyRateDs = new DataSource({
      paginate: false,
      store: this.hourlyRateStore,
    });
    this.initialized = true;
  }

  private startRealtime() {
    this.init();

    // Tracking events
    this.sub = this.ws.topicObserver('Tracker', Tracker).pipe(
      filter(e => e.imei === this.tracker.imei),
    ).subscribe((e) => {
      this.push(e);
    });

    /*this.interval = setInterval(() => {
      this.hourlyRateStore.push([{
        type: 'insert',
        data: {tracker_time: new Date(), fuel_hourly_consumption_rate: this.getRandomInt(5, 12)}
      }]);
    }, 2000);*/
  }

  private push(e: Tracker) {
    this.current = e;

    if (this.isFirst) {
      this.engineHoursBase = this.current.engine_hours;
      this.fuelTotalBase = this.current.fuel_total_consumption;
    }

    this.engineHours = this.current.engine_hours - this.engineHoursBase;
    this.fuelTotal = this.current.fuel_total_consumption - this.fuelTotalBase;

    this.hourlyRateStore.push([{
      type: 'insert',
      data: {tracker_time: this.current.tracker_time, fuel_hourly_consumption_rate: this.current.fuel_hourly_consumption_rate}
    }]);

    this.isFirst = false;
  }

  private stopRealtime() {
    // clearInterval(this.interval);

    this.sub.unsubscribe();

    this.reset();
  }

  private reset() {
    this.hourlyRateStore.clear();
    this.hourlyRateDs.reload();
    this.isFirst = true;
  }
}
